import { render, staticRenderFns } from "./QuestionToast.vue?vue&type=template&id=1bbe51ec&scoped=true&"
import script from "./QuestionToast.vue?vue&type=script&lang=js&"
export * from "./QuestionToast.vue?vue&type=script&lang=js&"
import style0 from "./QuestionToast.vue?vue&type=style&index=0&id=1bbe51ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe51ec",
  null
  
)

export default component.exports